import React from "react"
import { Container, Stack, Typography, Link, Divider, IconButton } from "@mui/material"
import { useAppSelector } from "@/hooks"

import { MapIcon, MailIcon, FacebookIcon, YoutubeIcon, TwitterIcon, FeedIcon, ChevronRight, InstagramIcon1 } from "../../assets/icons/index"
import { useLocation } from "@reach/router"

function CopyRight({ configDetails = null }: { configDetails: any }) {
  // let { configDetails: configDetailsState } = useAppSelector((state) => state.homePage)
  const location = useLocation()
  return (
    <Container className="CopyRightWrapper">
      <Divider />
      <Stack className="BottomWrapper">
        <Stack className="CopyRightContent">
          <Typography className="CopyRightText">{configDetails?.["Footer_Copyright_Text"]?.value ?? "Copyright © 2024 Queensland Mint. All rights reserved.*"}</Typography>
        </Stack>
        <Stack className="NewsletterPart">
          <Stack className="SocialWrapper">
            <IconButton title="Follow us on Facebook" target={"_blank"} href={configDetails?.SocialLinks_Facebook?.value ?? location?.href}><FacebookIcon fontSize="small" /></IconButton>
            <IconButton title="Follow us on Youtube" target={"_blank"} href={configDetails?.SocialLinks_Youtube?.value ?? location?.href}><YoutubeIcon /></IconButton>
            <IconButton title="Follow us on Twitter" target={"_blank"} href={configDetails?.SocialLinks_Twitter?.value ?? location?.href}><TwitterIcon fontSize="small" /></IconButton>
            <IconButton title="Follow us on Instagram" target={"_blank"} href={configDetails?.SocialLinks_Instagram?.value ?? location?.href}><InstagramIcon1 fontSize="small" /></IconButton>
          </Stack>
        </Stack>
      </Stack>
    </Container>
  )
}

export default React.memo(CopyRight)